/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { SVGIcons } from "cms/icons/svg-icons";
import React from "react";

export const openInNamedWindow = (event, url) => {
    const id = `${Math.random().toString(16).slice(2)}`;
    window.open(url, id, "popup");
};
export const DOCUMENT_STYLES = {
    BODY: "field.style.body",
    HEADING_ONE: "field.style.h1",
    HEADING_TWO: "field.style.h2",
    HEADING_THREE: "field.style.h3",
    // HEADING_FOUR: 'field.style.h4',
    // HEADING_FIVE: 'field.style.h5',
    // HEADING_SIX: 'field.style.h6',
};
export const DOCUMENT_STYLE_OPTIONS = [
    { name: "Body", value: DOCUMENT_STYLES.BODY },
    { name: "Heading 1", value: DOCUMENT_STYLES.HEADING_ONE },
    { name: "Heading 2", value: DOCUMENT_STYLES.HEADING_TWO },
    { name: "Heading 3", value: DOCUMENT_STYLES.HEADING_THREE },
    // { name: 'Heading 4', value: STYLES.HEADING_FOUR },
    // { name: 'Heading 5', value: STYLES.HEADING_FIVE },
    // { name: 'Heading 6', value: STYLES.HEADING_SIX },
];
export const DOCUMENT_FORMATS = {
    TITLE: "field.format.document-title",
    TITLE_SIZE: "field.format.document-title-size"
};
export const DOCUMENT_FORMAT_OPTIONS = [
    { name: "Title & Size", value: DOCUMENT_FORMATS.TITLE_SIZE },
    { name: "Title", value: DOCUMENT_FORMATS.TITLE },
];
export const DOCUMENT_FIELD_FORMATS = {
    ICON: "field.format.document-icon",
    BULLET: "field.format.document-bullet",
    SIMPLE: "field.format.document-simple",
    SIMPLE_NO_SIZE: "field.format.document-simple-no-size",
};
export const DOCUMENT_FIELD_FORMAT_OPTIONS = [
    { name: "Icon", value: DOCUMENT_FIELD_FORMATS.ICON },
    { name: "Bullet", value: DOCUMENT_FIELD_FORMATS.BULLET },
    { name: "Simple", value: DOCUMENT_FIELD_FORMATS.SIMPLE },
    { name: "Simple (no size)", value: DOCUMENT_FIELD_FORMATS.SIMPLE_NO_SIZE },
];
export const DOCUMENT_LIST = {
    ICON: "field.list.document-icon",
    BULLET: "field.list.document-bullet",
    SIMPLE: "field.list.document-simple",
    ACCORDION: "field.list.document-accordion",
};
export const DOCUMENT_LIST_STYLE_OPTIONS = [
    { name: "Icon List", value: DOCUMENT_LIST.ICON },
    { name: "Bullet List", value: DOCUMENT_LIST.BULLET },
    { name: "Simple List", value: DOCUMENT_LIST.SIMPLE },
    { name: "Accordion List", value: DOCUMENT_LIST.ACCORDION },
];
export const TARGETS = {
    TAB: { name: "tab", target: "_blank", handler: undefined },
    WINDOW: { name: "window", target: "_blank", handler: openInNamedWindow },
    SELF: { name: "self", target: "_self", handler: undefined },
};
export const DOCUMENT_TARGETS = {
    NEW: "_blank",
    SELF: "_self",
    PARENT: "_parent",
    TOP: "_top",
    DOWNLOAD: "_self", // FIXME: this isn't really a target type
};
export const DOCUMENT_TARGET_OPTIONS = [
    { name: "Open in a new tab", value: DOCUMENT_TARGETS.NEW },
    { name: "Open in this tab", value: DOCUMENT_TARGETS.SELF },
    // { name: 'Start download', value: DOCUMENT_TARGETS.DOWNLOAD },
];
export const ICON_COLOR = "#0E7490";

export const getSVGIconForType = (type) => {
    switch (type) {
        case "application/pdf":
            return (
                <span style={{ fill: ICON_COLOR }}>
                    <SVGIcons.files.PdfFile />
                </span>
            );
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
            return (
                <span style={{ fill: ICON_COLOR }}>
                    <SVGIcons.files.WordFile/>
                </span>
            );
        case "application/msword":
            return (
                <span style={{ fill: ICON_COLOR }}>
                    <SVGIcons.files.WordFile/>
                </span>
            );
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        case "application/vnd.ms-excel":
            return (
                <span style={{ fill: ICON_COLOR }}>
                    <SVGIcons.files.ExcelFile/>
                </span>
            );
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
            return (
                <span style={{ fill: ICON_COLOR }}>
                    <SVGIcons.files.PowerpointFile/>
                </span>
            );
        case "text/plain":
            return (
                <span style={{ fill: ICON_COLOR }}>
                    <SVGIcons.files.TextLinesFile/>
                </span>
            );
        case "text/csv":
            return (
                <span style={{ fill: ICON_COLOR }}>
                    <SVGIcons.files.CsvFile/>
                </span>
            );
        case "text/xml":
            return (
                <span style={{ fill: ICON_COLOR }}>
                    <SVGIcons.files.XmlFile/>
                </span>
            );
        case "application/x-zip-compressed":
            return (
                <span style={{ fill: ICON_COLOR }}>
                    <SVGIcons.files.ZipFile/>
                </span>
            );
        case "application/json":
            return (
                <span style={{ fill: ICON_COLOR }}>
                    <SVGIcons.files.CodeFile/>
                </span>
            );
        case "text/calendar":
            return (
                <span style={{ fill: ICON_COLOR }}>
                    <SVGIcons.files.TextLinesFile/>
                </span>
            );
        case "image/png":
            return (
                <span style={{ fill: ICON_COLOR }}>
                    <SVGIcons.files.ImageFile/>
                </span>
            );
        case "image/jpeg":
            return (
                <span style={{ fill: ICON_COLOR }}>
                    <SVGIcons.files.ImageFile/>
                </span>
            );
        case "video/mp4":
            return (
                <span style={{ fill: ICON_COLOR }}>
                    <SVGIcons.files.VideoFile/>
                </span>
            );
        case "video/quicktime":
            return (
                <span style={{ fill: ICON_COLOR }}>
                    <SVGIcons.files.VideoFile/>
                </span>
            );
        case "image/svg+xml":
            return (
                <span style={{ fill: ICON_COLOR }}>
                    <SVGIcons.files.ImageFile/>
                </span>
            );
        default:
            return (
                <span style={{ fill: ICON_COLOR }}>
                    <SVGIcons.files.QuestionFile/>
                </span>
            );
    }
};

export const getSVGIconForFile = (file) => {
    const type = file?.type || "";
    return getSVGIconForType(type);
};
export const getSVGIconForDocument = (document) => {
    return getSVGIconForType(document.file_type);
};

export const readTarget = (options) => {
    const { openIn } = options || {};
    switch (openIn) {
        case TARGETS.TAB.name:
            return TARGETS.TAB;
        case TARGETS.WINDOW.name:
            return TARGETS.WINDOW;
        case TARGETS.SELF.name:
            return TARGETS.SELF;
        default:
            return TARGETS.TAB;
    }
};

// const image_sample = {
//     id: 228,
//     guid: '1afb8ea8-b798-43fe-8e51-6a7cc8d06b78',
//     organization: '229dc6b8-b28d-459f-881e-f699cf7f3a1a',
//     title: 'joel-vodell-TApAkERW5pQ-unsplash.jpg',
//     description: null,
//     storage_account: 'simplicityappimages',
//     storage_container: 'images',
//     storage_filepath: 'joel-vodell-TApAkERW5pQ-unsplash.jpg',
//     storage_url: 'https://simplicityappimages.blob.core.windows.net/images/joel-vodell-TApAkERW5pQ-unsplash.jpg',
//     url: 'https://images-dnv.simplicitycms.ca/images/joel-vodell-TApAkERW5pQ-unsplash.jpg',
//     file_name: 'joel-vodell-TApAkERW5pQ-unsplash.jpg',
//     file_ext: 'jpg',
//     file_type: 'image/jpeg',
//     file_size: 3121975,
//     width: 680,
//     height: 400,
//     updated_at: '2022-10-13 20:12:59',
//     updated_by: '852725ec-ac64-452b-be05-e3b8f123a5bf',
//     created_at: '2022-10-13 20:12:59',
//     created_by: '852725ec-ac64-452b-be05-e3b8f123a5bf',
// }
